// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page-frame_wrapper__2JUiO","children":"page-frame_children__1inYc"};